import React from 'react';
import { Price } from 'components';
import { t } from 'ttag';
import PropTypes from 'prop-types';
import clsx from 'clsx';

function Product({ product, baseUrl }) {
  const renderSizes = sizesArray => {
    if (sizesArray) {
      return (
        <div className="text-xs font-normal text-dark-gray">
          <span>
            {t`Size`.toUpperCase()}
            {': '}
          </span>
          <span className="text-gray">
            {sizesArray.length > 4 ? (
              <span>{t`Many sizes available`}</span>
            ) : (
              <span>{sizesArray.join(', ')}</span>
            )}
          </span>
        </div>
      );
    }
    return null;
  };

  return (
    <li
      className="flex w-28 shrink-0 snap-center flex-col items-center gap-2 bg-white p-5 md:w-40"
      key={product.name}
    >
      <a
        className="flex w-28 shrink-0 cursor-pointer flex-col items-center gap-2 px-5 md:w-40"
        href={baseUrl ? `${baseUrl}${product.url}` : `${product.url}`}
        style={{ textDecoration: 'None' }}
      >
        <div
          className={clsx(
            'aspect-h-1 aspect-w-1 w-full bg-whisper bg-cover bg-center bg-no-repeat'
          )}
          style={{ backgroundImage: `url(${product.image})` }}
          role="img"
          aria-label={product.name}
        />
        <p className="line-clamp-3 lg:h-18 m-0 h-14 text-center text-xs font-bold text-night-rider lg:text-sm">
          {product.name}
        </p>
        <span className="h-14">
          <Price
            unitPrice={product.price}
            priceColor="green"
            currency={product.currency}
            display="column"
            rrpPrice={product.rrPrice}
            priceFontWeight="thin"
            priceSize="2xl"
            rrpSize="xs"
            priceColorDiscount="green"
            alignment="center"
          />
        </span>
      </a>
      <div className="h-10">{renderSizes(product.sizesArray)}</div>
    </li>
  );
}

Product.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string,
    image: PropTypes.string,
    isImageLoaded: PropTypes.bool,
    url: PropTypes.string,
    price: PropTypes.number,
    rrPrice: PropTypes.number,
    currency: PropTypes.string,
    sizesArray: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  baseUrl: PropTypes.string
};

Product.defaultProps = {
  baseUrl: 'https://www.unisportstore.com'
};

export default Product;
